export default "__VITE_ASSET__BOgYjxaM__"